class TimelineStyleOne {
  constructor(el) {
    this.el = el;
    this.navWrap = el.querySelector(".tl1-nav-wrap");
    this.navList = el.querySelector(".tl1-nav");
    this.navItems = [...el.querySelectorAll("[data-timeline-nav]")];
    this.blocks = [...el.querySelectorAll("[data-timeline-block]")];
    this.activeIndex = -1;

    if (!this.blocks.length || !this.navItems.length) return;

    this._bindNavClicks();
    this._initObserver();
    this._setActive(0);
  }

  /* ── Nav click: smooth scroll to corresponding block ── */
  _bindNavClicks() {
    this.el.addEventListener("click", (e) => {
      const btn = e.target.closest("[data-nav-index]");
      if (!btn) return;

      const index = parseInt(btn.dataset.navIndex, 10);
      const target = this.blocks[index];
      if (!target) return;

      target.scrollIntoView({ behavior: "smooth", block: "center" });
    });
  }

  /* ── IntersectionObserver: highlight nav when block is in view ── */
  _initObserver() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const index = parseInt(entry.target.dataset.timelineBlock, 10);
          this._setActive(index);
        });
      },
      {
        rootMargin: "-15% 0px -55% 0px",
        threshold: 0,
      },
    );

    this.blocks.forEach((block) => observer.observe(block));
  }

  /* ── Apply active + past classes, scroll nav on mobile ── */
  _setActive(index) {
    if (this.activeIndex === index) return;
    this.activeIndex = index;

    this.navItems.forEach((item, i) => {
      item.classList.toggle("is-active", i === index);
      item.classList.toggle("is-past", i < index);
    });

    /* Desktop: Auto-scroll the left column if it's taller than the screen */
    if (window.innerWidth > 900 && this.navWrap) {
      const activeItem = this.navItems[index];
      if (activeItem) {
        this.navWrap.scrollTo({
          top:
            activeItem.offsetTop -
            40 /* Gives a little breathing room above the active text */,
          behavior: "smooth",
        });
      }
    }

    /* Mobile nav: keep the active item centered when the bottom nav is visible. */
    if (window.innerWidth <= 680 && this.navList) {
      const activeItem = this.navItems[index];
      if (!activeItem) return;

      const navRect = this.navList.getBoundingClientRect();
      const itemRect = activeItem.getBoundingClientRect();
      const centeredLeft =
        this.navList.scrollLeft +
        itemRect.left -
        navRect.left -
        (navRect.width - itemRect.width) / 2;

      this.navList.scrollTo({
        left: centeredLeft,
        behavior: "smooth",
      });
    }
  }
}

/* ── Init all timeline sections on the page ── */
function initTimelineSections() {
  document
    .querySelectorAll('[data-section-type="timeline-style-1"]')
    .forEach((el) => {
      new TimelineStyleOne(el);
    });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initTimelineSections);
} else {
  initTimelineSections();
}

/* ── Shopify Theme Editor: reinit on section load/reorder ── */
document.addEventListener("shopify:section:load", (e) => {
  const section = e.target.querySelector(
    '[data-section-type="timeline-style-1"]',
  );
  if (section) new TimelineStyleOne(section);
});
